import { Typography } from 'design-system/src/components/Typography/Typography';
import styled from 'styled-components';
import { ResponsiveTitle } from './ResponsiveComponents';

const Subtitle = styled(Typography)`
  color: var(--grayscale-600);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export type SignupFlowContentProps = {
  className?: string;
  variant?: 'default' | 'demo';
};

export const SignupFlowContent = ({ className, variant = 'default' }: SignupFlowContentProps) => {
  const title = variant === 'demo' ? 'Schedule a demo today' : 'Free your practice to focus on care';

  return (
    <ContentWrapper className={className} data-fs-unmask="true">
      <ResponsiveTitle text={title} desktopTextAlign="left" />
      <Subtitle styledAs="bodyLargeDMSans">
        Let Tandem handle prior authorizations, affordability, and pharmacy coordination–all at no cost to providers or
        patients.
      </Subtitle>
    </ContentWrapper>
  );
};

export default SignupFlowContent;
